import { gql } from '@apollo/client';

// Flat fees
export const GET_FLAT_FEES = gql`
  query GetFlatFees($seasonId: String!) {
    myAccount {
      settings {
        currency
      }
    }
    flatFees(seasonId: $seasonId) {
      id
      name
      amountInCents
    }
  }
`;

export const CREATE_FLAT_FEE = gql`
  mutation CreateFlatFee($flatFeeInput: FlatFeeInput!, $seasonId: String!) {
    createFlatFee(flatFeeInput: $flatFeeInput, seasonId: $seasonId) {
      id
      name
      amountInCents
    }
  }
`;

export const DELETE_FLAT_FEE = gql`
  mutation DeleteFlatFee($id: String!) {
    deleteFlatFee(id: $id) {
      result
    }
  }
`;

// Percentage by category fees
export const GET_PCT_BY_CATEGORY_FEES = gql`
  query GetPctByCategoryFees($seasonId: String!) {
    pctByCategoryFees(seasonId: $seasonId) {
      id
      categoryId
      categoryName
      percentage
    }
  }
`;

export const CREATE_PCT_BY_CATEGORY_FEE = gql`
  mutation CreatePctByCategoryFee(
    $pctByCategoryFeeInput: PctByCategoryFeeInput!
    $seasonId: String!
  ) {
    createPctByCategoryFee(
      pctByCategoryFeeInput: $pctByCategoryFeeInput
      seasonId: $seasonId
    ) {
      id
      categoryId
      categoryName
      percentage
    }
  }
`;

export const UPDATE_PCT_BY_CATEGORY_FEE = gql`
  mutation UpdatePctByCategoryFee(
    $id: String!
    $updates: UpdatePctByCategoryFeeInput!
  ) {
    updatePctByCategoryFee(id: $id, updates: $updates) {
      id
      categoryId
      categoryName
      percentage
    }
  }
`;

export const DELETE_PCT_BY_CATEGORY_FEE = gql`
  mutation DeletePctByCategoryFee($id: String!) {
    deletePctByCategoryFee(id: $id) {
      result
    }
  }
`;

// Redemptions
export const GET_REDEMPTIONS = gql`
  query GetRedemptions($seasonId: String!) {
    redemptions(seasonId: $seasonId) {
      id
      name
      invoiceTotalModifier
      addAbsValueToSalesTotal
    }
  }
`;

export const CREATE_REDEMPTION = gql`
  mutation CreateRedemption(
    $redemptionInput: RedemptionInput!
    $seasonId: String!
  ) {
    createRedemption(redemptionInput: $redemptionInput, seasonId: $seasonId) {
      id
      name
      invoiceTotalModifier
      addAbsValueToSalesTotal
    }
  }
`;

export const DELETE_REDEMPTION = gql`
  mutation DeleteRedemption($id: String!) {
    deleteRedemption(id: $id) {
      result
    }
  }
`;
